import { c as _c } from "react/compiler-runtime";
import { passkeyClient } from "@better-auth/passkey/client";
import { createAuthClient } from "better-auth/react";
import { useMemo } from "react";
import { useI18n } from "@llmgateway/i18n/react";
import { useAppConfig } from "./config";

// React hook to get the auth client
export function useAuthClient() {
  const $ = _c(3);
  const config = useAppConfig();
  const {
    locale
  } = useI18n();
  const t0 = config.apiUrl + "/auth";
  let t1;
  if ($[0] !== locale || $[1] !== t0) {
    t1 = createAuthClient({
      baseURL: t0,
      fetchOptions: {
        headers: {
          "x-locale": locale
        }
      },
      plugins: [passkeyClient()]
    });
    $[0] = locale;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}

// React hook for auth methods
export function useAuth() {
  const $ = _c(7);
  const authClient = useAuthClient();
  let t0;
  if ($[0] !== authClient.getSession || $[1] !== authClient.sendVerificationEmail || $[2] !== authClient.signIn || $[3] !== authClient.signOut || $[4] !== authClient.signUp || $[5] !== authClient.useSession) {
    t0 = {
      signIn: authClient.signIn,
      signUp: authClient.signUp,
      signOut: authClient.signOut,
      useSession: authClient.useSession,
      getSession: authClient.getSession,
      sendVerificationEmail: authClient.sendVerificationEmail
    };
    $[0] = authClient.getSession;
    $[1] = authClient.sendVerificationEmail;
    $[2] = authClient.signIn;
    $[3] = authClient.signOut;
    $[4] = authClient.signUp;
    $[5] = authClient.useSession;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  return t0;
}